import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { Button, Typography, makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';

import { DeletePost } from '../api'
const useStyles = makeStyles((theme) => ({
  menu: {
    marginTop: "2.8rem",
  },
}));
const Feed = ({feed, fetchAllPost, snack}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  const handleCloseMenu = () => {
    setAnchorEl(null);
    //feeds/all
  };

  const handleDelete = async (id) => {
    let res = await DeletePost(id);
    snack((pre) => ({
      ...pre,
      open: true,
      message: res.data.message
    }))
    fetchAllPost();
  }
  return (
    <div className="At-Feed">
      <div className="At-feed-topbar">
        <div className="At-feed-user">
          {/* <Avatar
            className="At-feed-user-avatar"
            alt={"not found"}
            src={
                'https://images.unsplash.com/photo-1548048876-54a717fa3f8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXRodW1ibmFpbHx8NDM4OTU4M3x8ZW58MHx8fHw%3D&auto=format&fit=crop&w=420&q=60'
                // feed.avatar
            }
          /> */}
          <div className="At-feed-user-info">
            {/* <h5>Sandra Ingram</h5>
            <p>20m ago</p> */}
          </div>
        </div>
        <div className="">
          {/* <Button
            variant="contained"
            type="button"
            className="px-10 AtBtnRed mr-2"
          >
            <Typography>Follow</Typography>
          </Button> */}
          <IconButton
            aria-controls="menu"
            aria-haspopup="true"
            onClick={(event) => setAnchorEl(event.currentTarget)}
            // style={{ marginTop: "1.7rem" }}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
            className={classes.menu}
          >
            <MenuItem
              onClick={() => {
                handleDelete(feed._id);
              }}
            >
              Delete
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseMenu();
              }}
            >
              Block
            </MenuItem>
          </Menu>
        </div>
      </div>
      {/* body */}
      <div className="At-feed-body">
        <p>{feed.title}</p>
        {/* <div dangerouslySetInnerHTML={{__html: feed.discription}}></div> */}
        <div className="At-feed-media">
          <img
            src={
                feed.image
            }
          />
        </div>
      </div>
      {/* actions */}
      {/* <div className="At-feed-actions">
        <div className="At-feed-action">
          <ThumbUpAltOutlinedIcon />&nbsp; 2,245
        </div>
        <div className="At-feed-action">
          <SmsOutlinedIcon />&nbsp; 45
        </div>
        <div className="At-feed-action">
          <ShareOutlinedIcon />
        </div>
        
      </div> */}
    </div>
  );
};

export default Feed;
